export enum SummaryVisibility {
  Invisible = 1,
  Visible = 2,
  Link = 3,
}